"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../helper/utils");
var DateType = {
    type: function (errorMsg) {
        return function (target) {
            if (utils_1.isDate(target)) {
                return false;
            }
            return { message: errorMsg };
        };
    },
};
exports.default = DateType;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/type/date/index.js
// module id = 329
// module chunks = 0